import React from 'react';
import PropTypes from 'prop-types';

const IntensityFilter = ({ selected, onChange, className = '' }) => {
  const intensityLevels = [
    { value: 1, label: 'עדין מאוד', emoji: '🕊️', description: 'דיסקרטי' },
    { value: 2, label: 'עדין', emoji: '💨', description: 'עדין' },
    { value: 3, label: 'בינוני', emoji: '🔸', description: 'מאוזן' },
    { value: 4, label: 'חזק', emoji: '💪', description: 'בולט' },
    { value: 5, label: 'חזק מאוד', emoji: '💥', description: 'מוחצן' }
  ];

  return (
    <div className={className}>
      <h3 className="text-sm lg:text-base font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <span className="text-xl">💪</span>
        <span>עוצמת ניחוח</span>
      </h3>
      
      {/* Mobile: Horizontal Scrollable */}
      <div className="lg:hidden flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
        {intensityLevels.map((level) => (
          <button
            key={level.value}
            onClick={() => onChange(selected === level.value ? null : level.value)}
            className={`flex-shrink-0 flex flex-col items-center p-3 rounded-lg border-2 transition-all duration-300 min-w-[80px] ${
              selected === level.value
                ? 'bg-gradient-to-br from-purple-500 to-pink-500 text-white border-transparent shadow-lg scale-105'
                : 'bg-white border-gray-200 hover:border-gray-300'
            }`}
          >
            <div className="text-2xl mb-1">{level.emoji}</div>
            <div className={`text-xs font-semibold text-center ${selected === level.value ? 'text-white' : 'text-gray-900'}`}>
              {level.label}
            </div>
          </button>
        ))}
      </div>

      {/* Desktop: Slider with Labels */}
      <div className="hidden lg:block">
        <div className="space-y-3">
          {intensityLevels.map((level) => (
            <button
              key={level.value}
              onClick={() => onChange(selected === level.value ? null : level.value)}
              className={`w-full flex items-center gap-3 p-3 rounded-lg border-2 transition-all duration-300 ${
                selected === level.value
                  ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white border-transparent shadow-lg'
                  : 'bg-white border-gray-200 hover:border-gray-300 hover:shadow-md'
              }`}
            >
              {/* Intensity Dots */}
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <div
                    key={i}
                    className={`w-2 h-2 rounded-full transition-colors duration-300 ${
                      i < level.value
                        ? selected === level.value
                          ? 'bg-white'
                          : 'bg-gradient-to-r from-purple-500 to-pink-500'
                        : 'bg-gray-200'
                    }`}
                  />
                ))}
              </div>

              {/* Text */}
              <div className="flex-1 text-right">
                <div className={`text-sm font-semibold ${selected === level.value ? 'text-white' : 'text-gray-900'}`}>
                  {level.label}
                </div>
                <div className={`text-xs ${selected === level.value ? 'text-white/90' : 'text-gray-600'}`}>
                  {level.description}
                </div>
              </div>

              {/* Emoji */}
              <div className="text-2xl">{level.emoji}</div>

              {/* Check */}
              {selected === level.value && (
                <div className="text-white">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Clear Button */}
      {selected && (
        <button
          onClick={() => onChange(null)}
          className="mt-3 w-full text-sm text-gray-600 hover:text-gray-900 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
        >
          נקה בחירה
        </button>
      )}
    </div>
  );
};

IntensityFilter.propTypes = {
  selected: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default IntensityFilter;

